/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetUserPinPathParameters } from 'api/actions/get-user-pin/get-user-pin-path-parameters';
import { GetUserPinResponse } from 'api/actions/get-user-pin/get-user-pin-response';

type GetUserPinQueryParameters = Record<string, any>;

/**
 * The path of the GetUserPin action.
 */
export const getUserPinActionPath = new SweetPath<keyof GetUserPinPathParameters>('/user/pin', { path: '{param}' });

/**
 * Creates a contextualized GetUserPin actions.
 */
export default function createGetUserPinAction(axios: AxiosInstance) {
  return function getUserPinAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetUserPinQueryParameters } = {}) {
    const path = getUserPinActionPath.original;

    return axios.get<GetUserPinResponse, GetUserPinResponse>(path, { params: query, headers });
  };
}
